import React, { useState } from "react";

const CopyButton = ({ url }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(url).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500); // revert text after 1.5s
        });
    };

    return (
        <button
            type="button"
            className="btn btn-link p-0 text-decoration-none fs-md"
            onClick={handleCopy}
        >
            {copied ? "✔" : "Copy Link"}
        </button>
    );
};

export default CopyButton;
